import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Tooltip, useDisclosure } from '@heroui/react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Trash } from 'lucide-react'
import { toast } from 'react-toastify'
import { $fetch } from 'utils/fetch'

export default function DeleteSampleModal({ voiceId, sampleId, setSelectedSampleId }) {
  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure()

  const queryClient = useQueryClient()

  const { mutate: deleteSample, isPending } = useMutation({
    mutationFn: () => $fetch(`/v1/voices/${voiceId}/samples`, {
      method: 'DELETE',
      body: {
        sample_ids: [sampleId],
      },
    }),
    onSuccess: () => {
      toast.success('Sample deleted')
      setSelectedSampleId(null)
      queryClient.setQueryData(['samples', voiceId], old => old.filter(sample => sample.id !== sampleId))
      onClose()
    },
    onError: () => {
      toast.error('Error deleting sample')
    },
  })

  return (
    <>
      <Tooltip content="Delete sample">
        <button
          type="button"
          className="ml-2 p-1 text-gray-400 hover:text-red-500 shrink-0 transition-colors"
          onClick={onOpen}
        >
          <Trash size={12} />
        </button>
      </Tooltip>
      <Modal radius="sm" isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          <ModalHeader>Delete Sample</ModalHeader>
          <ModalBody>Are you sure you want to delete this sample?</ModalBody>
          <ModalFooter>
            <Button radius="sm" onPress={onOpenChange}>Cancel</Button>
            <Button radius="sm" color="danger" isLoading={isPending} onPress={deleteSample}>Confirm</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
